import type { ConfigurationSetup } from './config/config-setup.types';
import { TeoWritableStore } from './state/TeoStore';
import type { PromptOptionTemplate } from './TeoApi';

export type DynamicConfigOptions = {
  alwaysCheckBrandFit: boolean;
  evaluationProfileId: number;
  subscriptionName: string;
  textConfigOptions: ConfigurationSetup | null;
  useExpParser: boolean;
  testFeaturesEnabled: boolean;

  // --- Flags ---
  brandFitEnabled: boolean;
  textGeneratorEnabled: boolean;
  whitelistEnabled: boolean;
  dictionaryEnabled: boolean;
  plainLanguageEnabled: boolean;
  /** Whether the user may see debug details, such as the prompts the API used. */
  debugPermissions: boolean;
  promptOptionTemplates: PromptOptionTemplate[] | null;
};

export class DynamicConfigStore extends TeoWritableStore<DynamicConfigOptions> {
  constructor(options: Partial<DynamicConfigOptions> = {}) {
    super({
      alwaysCheckBrandFit: false,
      evaluationProfileId: 3,
      subscriptionName: '',
      textConfigOptions: null,
      useExpParser: false,
      testFeaturesEnabled: false,
      // Flags
      brandFitEnabled: false,
      textGeneratorEnabled: false,
      whitelistEnabled: true,
      dictionaryEnabled: true,
      plainLanguageEnabled: true,
      debugPermissions: false,
      promptOptionTemplates: null,
      ...options,
    });
  }

  get options() {
    return this.state;
  }

  getTemplateById(id: Maybe<string>): PromptOptionTemplate | null {
    if (!id) return null;
    return this.state.promptOptionTemplates?.find((t) => t.id === id) ?? null;
  }
}
